import { ApiKeysPanel } from '@/components/admin/ApiKeysPanel'

export function AdminSettings() {
  return (
    <div className="admin-client-view">
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Settings</h1>
          <p className="admin-page-sub">Operator configuration</p>
        </div>
      </div>

      <ApiKeysPanel />
    </div>
  )
}
